/**
 * Why the comment button is unavailable, as a translation key; `null` means it works. An empty
 * selection is not a reason: the toolbar is not shown for one at all.
 */
export type CommentButtonReason = "comment-over-comment" | "comment-not-here" | null;

type CommentButtonInput = {
	marks: string[];
	refusedByState: boolean;
};

const getCommentButtonReason = ({ marks, refusedByState }: CommentButtonInput): CommentButtonReason => {
	if (marks?.includes("comment")) return "comment-over-comment";
	if (refusedByState) return "comment-not-here";
	return null;
};

export default getCommentButtonReason;
